/**
 * Builder Encapsulated PDF Storage (Part-10 Explicit VR LE).
 */
import {
  concat,
  elCS,
  elDA,
  elIS,
  elLO,
  elOB,
  elPN,
  elSH,
  elST,
  elTM,
  elUI,
  newUid,
  nowDicomDate,
  nowDicomTime,
  wrapPart10,
} from './dicomPart10'
import { ENCAPSULATED_PDF_SOP } from './isNonImageInstance'

/**
 * @param {{
 *   pdfBytes: Uint8Array|ArrayBuffer,
 *   patientName?: string,
 *   patientId?: string,
 *   studyInstanceUID?: string,
 *   seriesInstanceUID?: string,
 *   studyDescription?: string,
 *   seriesDescription?: string,
 *   seriesNumber?: string|number,
 *   instanceNumber?: string|number,
 *   documentTitle?: string,
 * }} ctx
 */
export function buildEncapsulatedPdfFile(ctx) {
  const src = ctx && ctx.pdfBytes
  if (!src) throw new Error('pdfBytes requerido')
  const pdfBytes =
    src instanceof Uint8Array ? src : new Uint8Array(src)
  if (!pdfBytes.length) throw new Error('PDF vacío')
  if (
    pdfBytes[0] !== 0x25 ||
    pdfBytes[1] !== 0x50 ||
    pdfBytes[2] !== 0x44 ||
    pdfBytes[3] !== 0x46
  ) {
    throw new Error('Bytes no parecen un PDF (%PDF)')
  }

  const date = nowDicomDate()
  const time = nowDicomTime()
  const sopInstanceUid = newUid()
  const seriesUid = (ctx && ctx.seriesInstanceUID) || newUid()
  const studyUid = (ctx && ctx.studyInstanceUID) || newUid()
  const patientName = (ctx && ctx.patientName) || 'ANONYMOUS'
  const patientId = (ctx && ctx.patientId) || '0'
  const seriesDesc =
    (ctx && ctx.seriesDescription) ||
    (ctx && ctx.documentTitle) ||
    'INFORME PDF'
  const studyDesc = (ctx && ctx.studyDescription) || ''
  const seriesNumber = String(
    (ctx && ctx.seriesNumber) != null ? ctx.seriesNumber : '900'
  )
  const instanceNumber = String(
    (ctx && ctx.instanceNumber) != null ? ctx.instanceNumber : '1'
  )
  const docTitle =
    (ctx && ctx.documentTitle) || seriesDesc || 'Informe'

  const dataset = concat([
    elUI('x00080016', ENCAPSULATED_PDF_SOP),
    elUI('x00080018', sopInstanceUid),
    elDA('x00080020', date),
    elDA('x00080023', date),
    elTM('x00080030', time),
    elTM('x00080033', time),
    elCS('x00080060', 'DOC'),
    elLO('x00081030', studyDesc),
    elLO('x0008103e', seriesDesc),
    elPN('x00100010', patientName),
    elLO('x00100020', patientId),
    elUI('x0020000d', studyUid),
    elUI('x0020000e', seriesUid),
    elSH('x00200010', '1'),
    elIS('x00200011', seriesNumber),
    elIS('x00200013', instanceNumber),
    elCS('x00420010', 'PDF'),
    elOB('x00420011', pdfBytes),
    elLO('x00420012', 'application/pdf'),
    elST('x00420013', docTitle),
  ])

  const bytes = wrapPart10(dataset, {
    sopClassUid: ENCAPSULATED_PDF_SOP,
    sopInstanceUid,
  })

  return {
    bytes,
    sopInstanceUid,
    seriesInstanceUID: seriesUid,
    studyInstanceUID: studyUid,
    sopClassUID: ENCAPSULATED_PDF_SOP,
  }
}
